// extracted by mini-css-extract-plugin
module.exports = {"top-categories":"TopCategories_top-categories__13leL","title":"TopCategories_title__i5WyR","categories-container":"TopCategories_categories-container__1YE7a"};